import { useEffect, useState } from "react";

import { AUTH_REDIRECT_URL, SERVICE_WORKER_UPDATE_INTERVAL } from "./constants";

interface Props {
  onUpdate: () => void;
}

function isAuthenticationError(error: Error) {
  return error.message.includes("The script resource is behind a redirect");
}

export const useServiceWorker = ({ onUpdate }: Props) => {
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null);

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/reef/sw.js", { scope: "/reef/" })
        .then((reg) => {
          const updateCheckInterval = setInterval(() => {
            reg.update().catch((error) => {
              if (isAuthenticationError(error)) {
                window.location.href = AUTH_REDIRECT_URL;
              }
            });
          }, SERVICE_WORKER_UPDATE_INTERVAL); // Use configurable interval

          reg.addEventListener("updatefound", () => {
            const newWorker = reg.installing;
            newWorker?.addEventListener("statechange", () => {
              if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
                setWaitingWorker(newWorker);
                onUpdate();
              }
            });
          });

          return () => clearInterval(updateCheckInterval);
        })
        .catch((error) => {
          console.error("ServiceWorker registration failed: ", error);
        });
    }
  }, [onUpdate]);

  const update = (redirectUrl?: string) => {
    waitingWorker?.postMessage({ type: "SKIP_WAITING" });

    window.location.replace(redirectUrl || window.location.href);
  };

  return { update };
};
